import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useOfferTemplate, OfferTemplate } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<OfferTemplate>
      useData={useOfferTemplate}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
